<template>
  <!--    <BasicLayout>-->
  <el-container style="padding: 0px">
    <el-aside width="240px">
      <el-row type="flex" justify="start" align="middle" class="topTab" @click.native=""><span>会议计划</span></el-row>
      <el-row type="flex" justify="start" align="middle" :class="{ options: true, optionsActive: active == 1 }"
        @click.native="calendar1('1')"><span>会议信息</span></el-row>
      <el-row type="flex" justify="start" align="middle" :class="{ options: true, optionsActive: active == 2 }"
        @click.native="calendar1('2')"><span>会议议程</span></el-row>
      <el-row type="flex" justify="start" align="middle" :class="{ options: true, optionsActive: active == 3}"
        @click.native="calendar1('3')"><span>会议讲者</span></el-row>
      <el-row type="flex" justify="start" align="middle" :class="{ options: true, optionsActive: active == 4 }"
        @click.native="calendar1('4')"><span>邀请客户</span></el-row>
      <el-row type="flex" justify="start" align="middle" :class="{ options: true, optionsActive: active == 5 }"
        @click.native="calendar1('5')"><span>线下会议室</span></el-row>
      <el-row type="flex" justify="start" align="middle" :class="{ options: true, optionsActive: active == 6 }"
        @click.native="calendar1('6')"><span>腾讯会议</span></el-row>
      <el-row type="flex" justify="start" align="middle" class="topTab" @click.native=""><span>会议审查</span></el-row>
      <el-row type="flex" justify="start" align="middle" :class="{ options: true, optionsActive: active == 7 }"
        @click.native="calendar1('7')"><span>飞行检查</span></el-row>
      <el-row type="flex" justify="start" align="middle" :class="{ options: true, optionsActive: active == 8 }"
        @click.native="calendar1('8')"><span>线上参会客户</span></el-row>
      <el-row type="flex" justify="start" align="middle" :class="{ options: true, optionsActive: active == 9 }"
        @click.native="calendar1('9')"><span>线下参会客户</span></el-row>
      <el-row type="flex" justify="start" align="middle" :class="{ options: true, optionsActive: active == 10 }"
        @click.native="calendar1('10')"><span>内部人员</span></el-row>
      <el-row type="flex" justify="start" align="middle" :class="{ options: true, optionsActive: active == 11 }"
        @click.native="calendar1('11')"><span>会议回放</span></el-row>
    </el-aside>
    <el-main>
      <el-row class="navRouter">
        <span @click="handleBackClick">合规飞检</span><span>></span> <span style="color: #3998f7;">{{pageName}}</span>
      </el-row>
      <el-row class="navRouter" style="margin-top: 20px;border-bottom: 2px dashed #dcdfe6;padding-bottom: 70px;">
        <el-col :span="18">
          <div style="color: #3998f7; font-size: 20px;font-family: Hiragino Sans GB;">{{meetingInfo.subject}}</div>
          <div style="color: #7ED321; font-size: 14px;font-family: Hiragino Sans GB; margin-top: 20px;">
            {{meetingInfo.activity_date}} {{ fomartHM(meetingInfo.start_time)}}-{{ fomartHM(meetingInfo.end_time)}}
          </div>
        </el-col>
        <el-col :span="6">
          <el-button type="danger" icon="el-icon-return" style="float: right;" @click="handleBackClick">返回</el-button>
        </el-col>
      </el-row>

      <el-row style="margin-top:30px;margin-left: 10px;" v-if="active == 1">
        <el-col>
          <el-row>
            <el-col :span="24" style="margin-bottom: 40px;">
              <el-col :span="3" style="font-weight:bold;font-size: 14px ">营销项目</el-col>
              <el-col :span="6" style="color: #87909A;font-size: 14px">{{ meetingInfo.project_name }}</el-col>
            </el-col>
            <el-col :span="24" style="margin-bottom: 40px;">
              <el-col :span="3" style="font-weight:bold;font-size: 14px ">辖区</el-col>
              <el-col :span="6" style="color: #87909A;font-size: 14px">{{ meetingInfo.territory_name }}</el-col>
            </el-col>
            <el-col :span="24" style="margin-bottom: 40px;">
              <el-col :span="3" style="font-weight:bold;font-size: 14px ">主题</el-col>
              <el-col :span="6" style="color: #87909A;font-size: 14px">{{ meetingInfo.subject }}</el-col>
            </el-col>
            <el-col :span="24" style="margin-bottom: 40px;">
              <el-col :span="3" style="font-weight:bold;font-size: 14px ">会议日期</el-col>
              <el-col :span="6" style="color: #87909A;font-size: 14px">{{ meetingInfo.activity_date }}</el-col>
            </el-col>
            <el-col :span="24" style="margin-bottom: 40px;">
              <el-col :span="3" style="font-weight:bold;font-size: 14px ">开始时间</el-col>
              <el-col :span="6" style="color: #87909A;font-size: 14px">{{ fomartHM(meetingInfo.start_time) }}</el-col>
            </el-col>
            <el-col :span="24" style="margin-bottom: 40px;">
              <el-col :span="3" style="font-weight:bold;font-size: 14px ">结束时间</el-col>
              <el-col :span="6" style="color: #87909A;font-size: 14px">{{ fomartHM(meetingInfo.end_time) }}</el-col>
            </el-col>
            <!-- <el-col :span="24" style="margin-bottom: 40px;">
              <el-col :span="3" style="font-weight:bold;font-size: 14px ">推广产品</el-col>
              <el-col :span="18" style="color: #87909A;font-size: 14px">
                <el-tag effect="dark" type="warning" style="margin-right: 5px;" v-for="item in meetingInfo.productArray"
                  :key="item.product_id">
                  {{ item.product_name }}
                </el-tag>
              </el-col>
            </el-col> -->
            <el-col :span="24" style="margin-bottom: 40px;">
              <el-col :span="3" style="font-weight:bold;font-size: 14px ">类型</el-col>
              <el-col :span="6" style="color: #87909A;font-size: 14px">{{ meetingInfo.meeting_type_value }}</el-col>
            </el-col>
            <el-col :span="24" style="margin-bottom: 40px;">
              <el-col :span="3" style="font-weight:bold;font-size: 14px ">回放</el-col>
              <el-col :span="6" style="color: #87909A;font-size: 14px">{{ meetingInfo.playback=='T'?"允许回放":"不允许回放" }}
              </el-col>
            </el-col>
            <el-col :span="24" style="margin-bottom: 40px;">
              <el-col :span="3" style="font-weight:bold;font-size: 14px ">说明</el-col>
              <el-col :span="18" style="color: #87909A;font-size: 14px">{{ meetingInfo.comments }}</el-col>
            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <el-row style="margin-top:30px;margin-left: 10px;" v-if="active == 2">
        <el-col>
          <el-row :span="24" style="margin-bottom: 40px;" v-for="item in meetingInfo.agendaArray" :key="item.key_id">
            <el-col :span="2" style="font-weight:bold;font-size: 14px;color: #3998f7; ">{{meetingInfo.activity_date}}
            </el-col>
            <el-col :span="12" style="font-size: 14px">
              <div>{{ item.start_time }}-{{ item.end_time }}</div>
              <div style="margin-top: 20px;color: #87909A;">{{ item.speaker }}</div>
              <div style="margin-top: 20px;">{{ item.title }}</div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <el-row style="margin-top:30px;margin-left: 10px;" v-if="active == 3">
        <el-col>
          <span style="color: #4D586D;font-size: 15px;">讲者与听众人数比:</span>
          <span style="color: #ff9901;font-size: 15px;">1 :
            {{meetingInfo.speaker_audience_ratio?meetingInfo.speaker_audience_ratio:"0"}}</span>
        </el-col>
        <el-col>
          <el-row :span="24" style="margin-bottom: 40px;">
            <el-col
              style="border: 1px solid #ededed;width: 350px;height: 80px;margin-top: 10px;margin-right: 15px;position:relative"
              v-for="item in meetingInfo.speakerArray" :key="item.key_id">
              <div style="display: inline-block;width: 55px;height: 55px;border-radius: 50px;margin:15px auto 0;">
                <img src="../../assets/images/chat_header_image.png" width="100%" alt="" style="margin-left: 20px">
              </div>
              <span style="position: relative;top: -45px;margin-left: 26px">
                <span style="color: #4D586D;font-size: 15px;">{{item.speaker_name}}</span>
                <span v-if="item.pro_title"
                  style="color: #fff;border: 1px solid;background-color: #ff9901;border: 1px solid #ff9901;border-radius:5px;font-size: 11px;padding: 0 6px">{{item.pro_title}}</span>
              </span>
              <p style="position: relative;left: 86px;width: 262px;top: -40px;margin: 0">
                <span style="font-size: 13px;color:#B0B5B9" v-if="item.job_title">
                  {{item.job_title}} | {{item.department}}
                </span>
                <span style="height:16px;display: block" v-else>
                </span>
              </p>
              <div style="width: 262px;margin-top:-35px;float: right">
                <span style="color: #B0B5B9;font-size: 13px;position: relative;top: -2px;">
                  {{item.institution}}
                </span>
              </div>

              <el-row style="margin-bottom: 10px">
              </el-row>

            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <el-row style="margin-top:30px;margin-left: 10px;" v-if="active == 4">
        <el-col>
          <el-row :span="24" style="margin-bottom: 40px;">
            <el-col
              style="border: 1px solid #ededed;width: 350px;height: 80px;margin-top: 10px;margin-right: 15px;position:relative"
              v-for="item in meetingInfo.audienceArray" :key="item.key_id">
              <div style="display: inline-block;width: 55px;height: 55px;border-radius: 50px;margin:15px auto 0;">
                <img src="../../assets/images/chat_header_image.png" width="100%" alt="" style="margin-left: 20px">
              </div>
              <span style="position: relative;top: -45px;margin-left: 26px">
                <span style="color: #4D586D;font-size: 15px;">{{item.hcp_name}}</span>
                <span v-if="item.pro_title"
                  style="color: #fff;border: 1px solid;background-color: #ff9901;border: 1px solid #ff9901;border-radius:5px;font-size: 11px;padding: 0 6px">{{item.pro_title}}</span>
              </span>
              <p style="position: relative;left: 86px;width: 262px;top: -40px;margin: 0">
                <span style="font-size: 13px;color:#B0B5B9" v-if="item.job_title">
                  {{item.job_title}} | {{item.dept_name}}
                </span>
                <span style="height:16px;display: block" v-else>
                </span>
              </p>
              <div style="width: 262px;margin-top:-35px;float: right">
                <span style="color: #B0B5B9;font-size: 13px;position: relative;top: -2px;">
                  {{item.institution_name}}
                </span>
              </div>

              <el-row style="margin-bottom: 10px">
              </el-row>

            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <el-row style="margin-top:30px;margin-left: 10px;" v-if="active == 5">
        <el-col>
          <el-row :span="24" style="margin-bottom: 40px;">
            <el-col
              style="border: 1px solid #ededed;width: 350px;height: 80px;margin-top: 10px;margin-right: 15px;position:relative"
              v-for="item in meetingInfo.roomArray" :key="item.key_id">
              <div style="display: inline-block;width: 55px;height: 55px;border-radius: 50px;margin:15px auto 0;">
                <img src="../../assets/images/room.png" width="100%" alt="" style="margin-left: 20px">
              </div>
              <span style="position: relative;top: -35px;margin-left: 26px">
                <span style="color: #4D586D;font-size: 15px;">{{item.room_name}}</span>
              </span>

              <div style="width: 262px;margin-top:-20px;float: right">
                <span style="color: #B0B5B9;font-size: 13px;position: relative;top: -2px;">
                  计划参会人数: {{item.planned_participants}}
                </span>
              </div>

            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <el-row style="margin-top:30px;margin-left: 10px;" v-if="active == 6">
        <el-col>
          <el-row :span="24" style="margin-bottom: 40px; ">
            <el-col
              style="border: 1px solid #ededed;width: 600px;height: 380px;margin-top: 10px;margin-right: 15px;position:relative">
              <div style="text-align: center; margin-top: 30px;">
                <img src="https://cdn.meeting.tencent.com/pro/Y2JmNmM1ODYtNGFmYS00MzNkLWFhNDItOWJkOGUzODc5M2Ri.svg"
                  width="150px" alt="">
              </div>
              <div
                style="text-align: center; margin-top: 20px; font-size: 24px;font-weight:bold;font-family: Hiragino Sans GB">
                {{meetingInfo.subject}}
              </div>
              <div
                style="text-align: center; margin-top: 20px; font-size: 16px;font-family: Hiragino Sans GB;color: #3998f7">
                {{meetingInfo.meeting_no}}<i class="el-icon-copy-document" style="margin-left: 10px;"
                  @click="copyTxMeetingNo"></i>
              </div>
              <div style="text-align: center; margin-top: 40px; font-family: Hiragino Sans GB;">
                <el-row :span="24">
                  <el-col :span="7" :offset="1">
                    <div
                      style="text-align: center; margin-top: 20px; font-size: 20px;font-family: Hiragino Sans GB;color: #3998f7">
                      {{ fomartHM(meetingInfo.start_time)}}
                    </div>
                    <div style="text-align: center; margin-top: 20px; font-size: 16px;font-family: Hiragino Sans GB;">
                      {{meetingInfo.activity_date}}
                    </div>
                  </el-col>
                  <el-col :span="7" :offset="1">
                    <el-row :span="24">
                      <el-col :span="4" :offset="2">
                        <div style="width: 30px;border: 1px solid #bbbbbb;margin-top: 45px;"></div>
                      </el-col>
                      <el-col :span="10" :offset="2">
                        <div
                          style="text-align: center; margin-top: 20px; font-size: 20px;font-family: Hiragino Sans GB;color: #ff9901">
                          {{ fomartTxMeetingStatus(meetingInfo.tx_meeting_status)}}
                        </div>
                        <div
                          style="text-align: center; margin-top: 10px; font-size: 16px;font-family: Hiragino Sans GB;">
                          <el-tag type="info">{{meetingInfo.diffminute}}分钟</el-tag>
                        </div>

                      </el-col>
                      <el-col :span="4" :offset="2">
                        <div style="width: 30px;border: 1px solid #bbbbbb;margin-top: 45px;"></div>
                      </el-col>
                    </el-row>

                  </el-col>
                  <el-col :span="7" :offset="1">
                    <div
                      style="text-align: center; margin-top: 20px; font-size: 20px;font-family: Hiragino Sans GB;color: #3998f7">
                      {{fomartHM(meetingInfo.end_time)}}
                    </div>
                    <div style="text-align: center; margin-top: 20px; font-size: 16px;font-family: Hiragino Sans GB;">
                      {{meetingInfo.activity_date}}
                    </div>
                  </el-col>
                </el-row>
              </div>
              <div
                style="text-align: center; margin-top: 80px; font-size: 14px;font-family: Hiragino Sans GB;color: #4D586D">
                请复制会议号到腾讯会议APP中参与会议
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <el-row style="margin-top:30px;margin-left: 10px;" v-if="active == 7">

        <el-col>
          <el-row :span="24" style="margin-bottom: 40px;">
            <el-col :span="24">
              <el-button type="primary" icon="el-icon-upload2" @click="dialogUploadVisible=true">点击上传</el-button>
            </el-col>
          </el-row>
          <el-row :span="24">
            <el-col :span="1" v-for="item in meetingInfo.compliance_array" :key="item.key_id"
              style="margin-right: 20px; margin-top: 10px;">
              <el-image :src="item.url" style="width: 60px;height:60px;" lazy :preview-src-list="[item.url]">
              </el-image>
              <div style="padding: 4px;">
                <span style="font-size: 12px;">{{item.title}}</span>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <el-row style="margin-top:30px;margin-left: 10px;" v-if="active == 8">
        <el-col>
          <span style="color: #4D586D;font-size: 15px;">讲者与听众人数比:</span>
          <span style="color: #ff9901;font-size: 15px;">1 :
            {{meetingInfo.speaker_bili}}</span>
        </el-col>
        <el-col>
          <el-row :span="24" style="margin-bottom: 40px;">
            <el-col
              style="border: 1px solid #ededed;width: 400px;height: 90px;margin-top: 10px;margin-right: 15px;position:relative"
              v-for="item in meetingInfo.audienceArray" :key="item.key_id">
              <div style="display: inline-block;width: 55px;height: 55px;border-radius: 50px;margin:15px auto 0;">
                <img src="../../assets/images/chat_header_image.png" width="100%" alt="" style="margin-left: 20px">
              </div>
              <div style="position: relative;left: 85px;top: -55px; width: 305px;">
                <span style="color: #4D586D;font-size: 15px;">{{item.hcp_name}}</span>
                <span v-if="item.pro_title"
                  style="color: #fff;border: 1px solid;background-color: #ff9901;border: 1px solid #ff9901;border-radius:5px;font-size: 11px;padding: 0 6px">{{item.pro_title}}</span>
                <span
                  style="float: right; margin-right: 10px;color: #3998f7;font-size: 13px;">参会时长:{{formartMuite(item.duration)}}分钟</span>
              </div>
              <p style="position: relative;left: 85px;width: 262px;top: -48px;margin: 0">
                <span style="font-size: 13px;color:#B0B5B9">
                  {{item.job_title}}{{item.dept_name}}
                </span>
              </p>
              <div style="position: relative;left: 85px;margin-top:-40px;">
                <span style="color: #B0B5B9;font-size: 13px;position: relative;top: -2px;">
                  {{item.institution_name}}
                </span>
              </div>
              <el-row style="margin-bottom: 10px">
              </el-row>

            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <el-row style="margin-top:30px;margin-left: 10px;" v-if="active == 9">
        <el-col>
          <span style="color: #4D586D;font-size: 15px;">讲者与听众人数比:</span>
          <span style="color: #ff9901;font-size: 15px;">1 :
            {{meetingInfo.speaker_bili}}</span>
        </el-col>
        <el-col v-if="meetingInfo.roomArray.length>0">
          <el-row :span="24" style="margin-bottom: 40px;">
            <el-col style="border: 1px solid #ededed;margin-top: 10px;margin-right: 15px;position:relative"
              v-for="item in meetingInfo.roomArray" :key="item.key_id">
              <el-row>
                <div style="display: inline-block;width: 55px;height: 55px;border-radius: 50px;margin:15px auto 0;">
                  <img src="../../assets/images/room.png" width="100%" alt="" style="margin-left: 20px">
                </div>
                <span style="position: relative;top: -35px;margin-left: 26px">
                  <span style="color: #4D586D;font-size: 15px;">{{item.room_name}}</span>
                </span>

                <div style="margin-left: 85px; margin-top:-20px;">
                  <span style="color: #B0B5B9;font-size: 13px;">
                    计划参会人数: {{item.planned_participants}}
                  </span>
                  <span style="color: #3998f7;font-size: 13px; margin-left: 10px;">
                    实际参会人数: {{item.reality_participants}}
                  </span>
                </div>
              </el-row>
              <el-row style="margin-top: 20px;">
                <el-col :span="1" v-for="(subitem, subindex) in item.photosList" :key="subindex"
                  style="margin-left: 20px;">
                  <el-image :src="subitem.url" style="width: 60px;height:60px;" lazy :preview-src-list="[subitem.url]">
                  </el-image>
                  <div style="padding: 4px;">
                    <span style="font-size: 12px;">{{subitem.title}}</span>
                  </div>
                </el-col>
              </el-row>

            </el-col>
          </el-row>
        </el-col>
        <div v-if="meetingInfo.roomArray.length==0"
          style="width: calc(100%);height: calc(100% - 50px) ; margin-top: 100px;">
          <img src="../../assets/images/691C8AAA4F3F3242DF42BB05FCAFB165.png" style="margin:0 auto;display: block;"
            alt="">
        </div>
      </el-row>

      <el-row style="margin-top:30px;margin-left: 10px;" v-if="active == 10">

        <el-col v-if="meetingInfo.timeframeArray.length>0">
          <el-row :span="24" style="margin-bottom: 40px;">
            <el-col
              style="border: 1px solid #ededed;width: 350px;height: 80px;margin-top: 10px;margin-right: 15px;position:relative"
              v-for="item in meetingInfo.timeframeArray" :key="item.key_id">
              <div style="display: inline-block;width: 55px;height: 55px;border-radius: 50px;margin:15px auto 0;">
                <img src="../../assets/images/chat_header_image.png" width="100%" alt="" style="margin-left: 20px">
              </div>
              <span style="position: relative;top: -45px;margin-left: 26px">
                <span style="color: #4D586D;font-size: 15px;">{{item.nickname}}</span>
                <span v-if="item.pro_title"
                  style="color: #fff;border: 1px solid;background-color: #ff9901;border: 1px solid #ff9901;border-radius:5px;font-size: 11px;padding: 0 6px">{{item.pro_title}}</span>
              </span>
              <p style="position: relative;left: 86px;width: 262px;top: -40px;margin: 0">
                <span style="font-size: 13px;color:#B0B5B9" v-if="item.job_title">
                  {{item.job_title}} | {{item.dept_name}}
                </span>
                <span style="height:16px;display: block" v-else>
                </span>
              </p>
              <div style="width: 262px;margin-top:-35px;float: right">
                <span style="color: #B0B5B9;font-size: 13px;position: relative;top: -2px;">
                  {{item.institution_name}}
                </span>
              </div>

              <el-row style="margin-bottom: 10px">
              </el-row>

            </el-col>
          </el-row>
        </el-col>
        <div v-if="meetingInfo.timeframeArray.length==0"
          style="width: calc(100%);height: calc(100% - 50px) ; margin-top: 100px;">
          <img src="../../assets/images/691C8AAA4F3F3242DF42BB05FCAFB165.png" style="margin:0 auto;display: block;"
            alt="">
        </div>
      </el-row>

      <el-row style="margin-top:30px;margin-left: 10px;" v-if="active == 11">

        <el-col v-if="meetingInfo.record_array.length>0">
          <el-row style="margin-bottom: 40px;">
            <el-col class="flex flex-between"
              style="border: 1px solid #ededed;width: 350px;height: 50px;margin-top: 10px; "
              v-for="item in meetingInfo.record_array" :key="item.record_file_id">
              <div style="font-size: 13px;margin-top: 20px;margin-left: 20px;float: left;">
                {{item.record_start_time}} - {{item.record_end_time}}
              </div>
              <el-button type="primary" size="mini"
                style="float: right; text-align: center;margin-right: 10px;margin-top: 10px;"
                @click="playVideo(item.download_address)">查看</el-button>
            </el-col>
          </el-row>
        </el-col>
        <div v-if="meetingInfo.record_array.length==0"
          style="width: calc(100%);height: calc(100% - 50px) ; margin-top: 100px;">
          <img src="../../assets/images/691C8AAA4F3F3242DF42BB05FCAFB165.png" style="margin:0 auto;display: block;"
            alt="">
        </div>
      </el-row>
    </el-main>

    <!--上传图片-->
    <el-dialog :visible.sync="dialogUploadVisible" width="600px" :show-close="false">
      <div style="margin-top: -40px;">
        <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 10px;">
          <el-col :span="9">
            <div style="color: #3998F7;padding-top: 8px;font-size: 22px">上传图片</div>
          </el-col>
          <el-col :span="15">
            <div align="right" style="float: right;">
              <el-button type="primary" size="small" @click="handleAddUpload()" style="margin-left: 10px;">
                保存
              </el-button>
              <el-button type="danger" size="small" @click="quxiao">
                取消
              </el-button>
            </div>
          </el-col>
        </el-row>

        <div class="subjectList" style="margin-top: 20px;">
          <el-form ref="formVersion" label-width="100px" class="myElForm demo-ruleForm" :model="uploadObj" :rules="rule"
            hide-required-asterisk>

            <el-form-item label="标题" prop="title">
              <el-input type="text" v-model="uploadObj.title" :rows="4"></el-input>
            </el-form-item>
            <el-form-item label="上传文件" ref="picUpload" class="a_upload_file upload_star" prop="picsUrls">
              <el-upload accept=".jpg,.png,.jpeg" :multiple="false" :action="getUrl()" list-type="picture-card"
                :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :on-success="handleImgSuccess"
                :before-upload="beforeImgUpload" :file-list="fileList">
                <i class="el-icon-plus"></i>
              </el-upload>
              <p>单个文件大小不能超过20M。</p>
              <p style="color: #4A90E2;font-weight: bold;">
                请待进度条走到 100%并出现<i class="el-icon-circle-check"
                  style="color: green;font-size: 16px;margin-left: 5px;margin-right: 5px"></i>之后保存，方为上传成功!
              </p>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-dialog>

    <!-- 视频播放-->
    <el-dialog title="视频预览" :visible.sync="dialogPlay" v-model="dialogPlay" width="40%" @close="closeVideoDialog">
      <video :src="videoUrl" controls autoplay class="video" ref="dialogVideo" width="100%" height="100%">
        <source type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"'>
      </video>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" style="position: relative; z-index: 9999" alt="" />
    </el-dialog>
  </el-container>
  <!--    </BasicLayout>-->
</template>

<script>
  import axios from "axios";
  import http from "../../APIService/http";
  import moment from 'moment'
  import { MessageBox, Message } from 'element-ui'

  export default {
    name: "index",
    components: {
      // BasicLayout
    },
    data() {
      return {
        rule: {
          title: [{ required: true, trigger: "blur", message: "此项不能为空" }],
        },
        dialogUploadVisible: false,
        dialogVisible: false,
        dialogPlay: false,
        dialogImageUrl: "",
        videoUrl: "",
        form: null,
        meetingInfo: {
          compliance_array: [],
          record_array: []
        },
        active: 1,
        options: [],
        pageName: "会议详情",
        compliance_title: "",
        filelist: [],
        clientObj: {},
        uploadObj: {
          title: "",
        },
        fileList: [],
        fileSaveList: [],
        tempUploadFile: null
      };
    },
    created() {
      this.clientObj = this.$store.getters.getClient;
      // console.log(this.$store.getters.getClient,111)
      this.active = 1;

      this.form = this.$route.params;
      this.init();

    },
    mounted() {
      // this.getManager()
      debugger;
    },
    watch: {

    },
    methods: {
      getUrl() {
        return (
          "/photos/uploadphoto_v2?tenant_id=" +
          this.$store.getters.getUser.tenant_id +
          "&reference_obj=MEETING_COMPLIANCE&category=PICTURE&title=" + this.compliance_title + "&user_id=" +
          this.$store.getters.getUser.user_id
        );
      },
      fomartHM(dt) {
        return moment(dt).format("HH:mm")
      },
      fomartTxMeetingStatus(value) {
        if (value == "INIT") {
          return "待开始"
        } else if (value == "STARTED") {
          return "进行中"
        } else if (value == "ENDED") {
          return "已结束"
        } else {
          return "未预定"
        }
      },
      formartMuite(seconds) {
        if (seconds > 0) {
          let h = Math.floor(seconds / 3600);
          let m = Math.floor((seconds % 3600) / 60);
          let s = Math.floor(seconds % 60);

          h = h < 10 ? '0' + h : h;
          m = m < 10 ? '0' + m : m;
          s = s < 10 ? '0' + s : s;

          return `${h}:${m}:${s}`;

        } else {
          return 0;
        }
      },
      copyTxMeetingNo() {
        var element = this.createElement(this.meetingInfo.meeting_no);
        element.select();
        element.setSelectionRange(0, element.value.length);
        document.execCommand('copy');
        element.remove();
        this.$message.success('复制成功')
      },
      createElement(text) {
        var isRTL = document.documentElement.getAttribute('dir') === 'rtl';
        var element = document.createElement('textarea');
        // 防止在ios中产生缩放效果
        element.style.fontSize = '12pt';
        // 重置盒模型
        element.style.border = '0';
        element.style.padding = '0';
        element.style.margin = '0';
        // 将元素移到屏幕外
        element.style.position = 'absolute';
        element.style[isRTL ? 'right' : 'left'] = '-9999px';
        // 移动元素到页面底部
        let yPosition = window.pageYOffset || document.documentElement.scrollTop;
        element.style.top = `${yPosition}px`;
        //设置元素只读
        element.setAttribute('readonly', '');
        element.value = text;
        document.body.appendChild(element);
        return element;
      },
      async init() {
        let loading = this.$loading({
          lock: true,
          text: '拼命加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

        try {
          let user = this.$store.getters.getUser
          let data = {
            tenant_id: user.tenant_id,
            activity_id: this.form.activity_id
          }
          await http.post('/echo/online/web/meeting/getMeetingByActivityId', data).then(res => {
            loading.close()
            debugger;
            if (res.success === true) {
              // this.meetingInfo = res.data;
              this.resetData(res.data);
            }
          })
        } catch (e) {
          loading.close();
          Message({
            type: "error",
            message: "请返回重新选择",
          });
        } finally {
          loading.close();
        }
      },
      async resetData(data) {
        data.reality_participants_count = 0
        for (let index = 0; index < data.roomArray.length; index++) {
          const room = data.roomArray[index];
          data.reality_participants_count = data.reality_participants_count + room.reality_participants;
          for (let i = 0; i < room.photosList.length; i++) {
            const element = room.photosList[i];
            let imgObj = await this.getImgInfo(element.photo_id)
            element["url"] = imgObj.url;
            element["title"] = imgObj.title;
          }
        }
        for (let index = 0; index < data.audienceArray.length; index++) {
          const audien = data.audienceArray[index];
          if (audien.duration) {
            data.reality_participants_count = data.reality_participants_count + 1;
          }
        }
        data.speaker_bili = data.speakerArray.length == 0 ? 0 : parseInt(parseInt(data.reality_participants_count) / parseInt(data.speakerArray.length));
        this.meetingInfo = { ...this.meetingInfo, ...data };
        this.meetingInfo.diffminute = moment(this.meetingInfo.end_time).diff(moment(this
          .meetingInfo.start_time), "minutes");
      },
      handleBackClick() {
        this.$router.go(-1)
      },
      calendar1(tav) {
        this.active = tav;
        if (tav == 7) {
          this.getComplianceList();
        } else if (tav == 11) {
          this.getRecordAddressList();
        }

      },
      async getRecordAddressList() {
        try {
          // this.loading = true;
          let loading = this.$loading({
            lock: true,
            text: '拼命加载中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          let data = {
            meeting_id: this.form.activity_id,
            tenant_id: this.$store.getters.getUser.tenant_id,
          };
          debugger;
          await http.post("/echo/online/meeting/txMeetingRecordAddressList", data).then((res) => {
            loading.close();
            if (res.success) {
              this.meetingInfo.record_array = res.data
            }
          });
        } catch (err) {
          this.message(err)
        } finally {
          loading.close();
        }
      },
      async getComplianceList() {
        try {
          // this.loading = true;

          let data = {
            meeting_id: this.form.activity_id,
            tenant_id: this.$store.getters.getUser.tenant_id,
          };
          debugger;
          let res = await http.post("/echo/online/web/meeting_compliance/getMeetingCompliance", data).then((response) => {
            if (response.success) {

              this.resetComplianceData(response.data);
            }
          });
        } catch (err) {
        }
      },
      async resetComplianceData(data) {
        for (let i = 0; i < data.length; i++) {
          const element = data[i];
          let imgObj = await this.getImgInfo(element.photo_id)
          element["url"] = imgObj ? imgObj.url : "";
          element["title"] = imgObj ? imgObj.title : "";
        }
        this.meetingInfo.compliance_array = data;
        console.log("=======================")
        console.log(this.meetingInfo.compliance_array)
      },
      async getImgInfo(photo_ids) {
        try {
          // this.loading = true;
          let obj = null;
          let data = {
            photo_ids: photo_ids,
            tenant_id: this.$store.getters.getUser.tenant_id,
            headersContentType: "multipart/form-data",
          };
          debugger;
          let res = await http.post("/photos/downloadphotos", data).then((response) => {
            if (response.success) {
              debugger;
              obj = response.data[0];
            }
          });
          return obj;
        } catch (err) {
        }
      },
      async handleAddUpload() {
        try {
          // if (this.fileList.length == 0) {
          //   this.error("请先上传图片");
          //   return;
          // }

          await this.resetImgTitle();
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id,
            user_id: this.$store.getters.getUser.user_id,
            meeting_id: this.form.activity_id,
            photo_id: this.fileList[0].file_id,
          };
          debugger;

          let res = await http.post("/echo/online/web/meeting_compliance/saveMeetingCompliance", data).then((response) => {
            if (response.success) {
              this.getComplianceList();
              this.quxiao();

            } else {
              this.error("提交失败")
            }
          });
        } catch (err) {
        }
      },
      async quxiao() {
        this.fileList = []
        this.uploadObj.title = "";
        this.dialogUploadVisible = false;
      },
      async resetImgTitle() {
        let data = {
          photo_id: this.fileList[0].file_id,
          title: this.uploadObj.title
        };
        debugger;

        let res = await http.post("/photos/saveImgTitle", data).then((response) => {
          if (response.success) {

          } else {
            this.error("提交失败")
          }
        });
      },
      // 上传图片成功
      handleImgSuccess(res, file, fileList) {
        debugger;
        console.log("----------------res----------");
        console.log(res);
        console.log("----------------file----------");
        console.log(file);
        console.log("----------------fileList----------");
        console.log(fileList);
        if (res.success === true) {
          // this.Tlist = [];
          this.fileList = [];
          let obj = {
            file_id: file.response.data.s3filename,
            file_name: file.response.data.filename,
            file_type: file.response.data.filetype,
            file_size: file.response.data.filesize,
            name: file.name,
            url: file.url
          };
          this.fileList.push(obj);
        } else {
          this.error("上传失败");
        }
      },
      // 上传图片前的验证
      beforeImgUpload(file) {
        console.log("------beforeImgUpload2-----");
        console.log(JSON.stringify(file));
        const isPic = file.type === "application/x-jpg" || file.type === "image/jpeg" || file.type === "application/x-png" || file.type === "image/png";
        const isLt20M = file.size / 1024 / 1024 < 20 * 1.2;
        this.file_size = file.size;

        if (!isPic) {
          this.error("上传图片只能是 jpg 或png 格式!");
        }
        if (!isLt20M) {
          this.error("上传图片大小不能超过 20MB!");
        }
        const nameArr = file.name.split(".");
        console.log(nameArr);
        // this.pic.picsUrls.push({ type: nameArr[nameArr.length - 1], status: "success" });
        this.tempUploadFile = null;
        return isPic && isLt20M;
      },
      //图片
      handleRemove(file, fileList) {
        console.log(file, fileList);

        this.fileList = fileList;

        console.log("------------删除前------------");
        console.log(this.fileSaveList);

        if (fileList.length === 0) {
          // this.pic.picsUrls = [];
          // this.video.id = "";
          // this.audio.id = "";
          // this.doc.pdfId = "";
          // this.ppt.id = "";
          this.fileSaveList = [];
        } else {
          this.fileSaveList = [];
          fileList.forEach((item) => {
            if (item.response) {
              let obj = {
                file_id: item.response.data.s3filename,
                file_name: item.response.data.filename,
                file_type: item.response.data.filetype,
                file_size: item.response.data.filesize,
              };
              this.fileSaveList.push(obj);
            } else {
              let obj = {
                file_id: item.file_id,
                file_name: item.file_name,
                file_type: item.file_type,
                file_size: item.file_size,
              };
              this.fileSaveList.push(obj);
            }
          });
        }
        console.log("------------删除后------------");
        console.log(this.fileSaveList);
        // for (var i = 0; i < this.pic.picsUrls.length; i++) {
        //     var pic = this.pic.picsUrls[i];
        //     if (pic.id == file.response.data.id) {
        //         this.pic.picsUrls.splice(i, 1);
        //         return;
        //     }
        // }
      },
      handlePictureCardPreview(file) {
        console.log(JSON.stringify(file));
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },

      // 视频
      playVideo(url) {
        this.dialogPlay = true;
        this.videoUrl = url;
      },
      closeVideoDialog() {
        this.videoUrl = ""; //清空数据 关闭视频播放
        this.dialogPlay = false;
      },
    },
    beforeRouteLeave(to, from, next) {
      localStorage.setItem("active", 1);

      next();
    },
    beforeRouteUpdate(to, from, next) {
      if (to.name === "calendarTable") {
        this.active = 1;
      }
      next();
    },
  };
</script>

<style scoped>
  .topTab {
    font-size: 18px;
    height: 60px;
    padding-left: 40px;
    color: #bbbbbb;
  }

  .el-aside {
    background: #f4f6f8;
    padding: 15px 0;
    /*border: 1px solid #DCDFE6;*/
  }

  .el-main {
    background: white;
    /*border: 1px solid #DCDFE6;*/
    border-left: none;
    padding: 34px 20px 10px;
  }

  .options {
    cursor: pointer;
    height: 45px;
    font-family: "Hiragino Sans GB";
    font-size: 16px;
    color: #323232;
    padding-left: 70px;
    user-select: none;
  }


  .optionsActive {
    cursor: pointer;
    height: 45px;
    font-family: Hiragino Sans GB;
    font-size: 16px;
    color: #323232;
    padding-left: 70px;
    user-select: none;
    color: #3998f7;
    font-weight: bold;
  }

  .el-container {
    min-height: 100%;
  }

  .navRouter {
    cursor: pointer;
    height: 40px;
    font-family: Hiragino Sans GB;
    font-size: 16px;
    color: #323232;
    margin-left: 10px;
  }

  .navRouter span {
    margin-right: 10px;
  }
</style>


// WEBPACK FOOTER //
// src/pages/echo/compliance_detail.vue